import getCompanyIssuerLinkProps from "components/financials/modern/getCompanyIssuerLinkProps";
import type { IPlatformVertical } from "types/graphqlTypes";

export default function getTickerSymbolSwitchUrl(
  tickerSymbol: string,
  vertical: IPlatformVertical,
  pathname: string,
  tab: string | null,
) {
  const links = getCompanyIssuerLinkProps({
    tickerSymbol,
    vertical,
  });

  const menuToRedirect = pathname.split("/")[3];

  if (!menuToRedirect && !tab) {
    return links;
  }

  if (menuToRedirect && !tab) {
    return {
      href: `${links.href}/${menuToRedirect}`,
      as: `${links.as}/${menuToRedirect}`,
    };
  }

  return {
    href: `${links.href}/${menuToRedirect}?tab=${tab}`,
    as: `${links.as}/${menuToRedirect}?tab=${tab}`,
  };
}
